import React, { Component } from 'react';
import firebase  from 'firebase/app';
import 'firebase/auth'

import {TextField} from 'office-ui-fabric-react/lib/TextField';
import {PrimaryButton,DefaultButton} from 'office-ui-fabric-react/lib/Button';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';

// import Test from './Test';

export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            currentItem: '',
            username: '',
            items: [],
            email:'',
            password: '',
            message: '',
            user: null // <-- add this line
          }    

        this.handleEmailChanged = this.handleEmailChanged.bind(this);
        this.handlePasswordChanged = this.handlePasswordChanged.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.handleSignIn = this.handleSignIn.bind(this);
        this.handleSignOut = this.handleSignOut.bind(this);
        this.handleAuthStateChanged = this.handleAuthStateChanged.bind(this);
        this.handleError = this.handleError.bind(this);
        


      }

      componentDidMount() {
        firebase.auth().onAuthStateChanged(this.handleAuthStateChanged);
      }

      handleEmailChanged(value) {
        this.setState({email: value});
      }
    
      handlePasswordChanged(value) {
        this.setState({password: value});
      }

      handleError(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        this.setState({message: errorMessage})
        // ...
      }

      handleSignIn(event) {
        const email = this.state.email
        const password = this.state.password        
        firebase.auth().signInWithEmailAndPassword(email, password).catch(this.handleError);
        event.preventDefault();
      }

      handleRegister(event) {

        alert('Account created for: ' + this.state.email);
        const email = this.state.email
        const password = this.state.password
        firebase.auth().createUserWithEmailAndPassword(email, password)
            .catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log(error.message);
            // ...
          });
        event.preventDefault();
      }

      handleAuthStateChanged(user) {
          if (user) {
            this.setState({user, message:''})
            // User is signed in.
            // See services/auth.js
            this.props.loadData(user)
          } else {
            // User is signed out.
            this.setState({user: null})
          }
      }
    handleSignOut() {
      firebase.auth().signOut();
    }

    render() {
        const {user, isOpen} = this.state
        console.log(window.navigator)

        return (this.state.user) 
          ? <div>
              <div className="ms-Grid">
                <div className="ms-Grid-row"><div className="ms-Grid-col ms-lgPush10 ms-lg2">
                  <DefaultButton text={'Sign Out'} onClick={this.handleSignOut} />
                  </div></div>
              </div>
            
          </div>
          : <form method="POST" onSubmit={this.handleSignIn}>
            <div className="ms-Grid-row"><div className="ms-Grid-col ms-lgPush10 ms-lg2">            
            {isOpen ?  <DefaultButton text='New Account' onClick={this.handleRegister}/> : ''}
            </div></div>
            <div className="ms-Grid">
            <div className="ms-Grid-row"><div className="ms-Grid-col ms-lgPush4 ms-lg2">
            <TextField name='email' label='Email' value={this.state.email} onChanged={this.handleEmailChanged} required={true}/>
            </div></div>
            <div className="ms-Grid-row"><div className="ms-Grid-col ms-lgPush4 ms-lg2">
            <TextField name='password' label='Password' value={this.state.password}  onChanged={this.handlePasswordChanged} type='password' required={true} />
            </div></div>
            <div className="ms-Grid-row"><div className="ms-Grid-col ms-lgPush4 ms-lg2">
            <br/>
            <PrimaryButton text='Sign In' onClick={this.handleSignIn}/>
            
            {this.state.message 
              ? <MessageBar
              messageBarType={ MessageBarType.error }
              isMultiline={ true }>
              {this.state.message}
              </MessageBar>
              : ''}
            </div></div>
            </div>
            {/*<Test />*/}
            
        </form>
    }
}


// WEBPACK FOOTER //
// ./src/login/components/Login.js